import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { ProductCategoryService } from 'src/app/modules/sales/services/product-category.service';
import { OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
import { ProductCategory } from 'src/app/core/interfaces/product-category.interface';
import * as $ from 'jquery';
import 'jstree';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-categories-tree',
  templateUrl: './categories-tree.component.html',
  styleUrl: './categories-tree.component.scss'
})
export class CategoriesTreeComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  @ViewChild('treeContainer', { static: true }) treeContainer!: ElementRef;

  currentLang?: string;

  constructor(private productCategoriesService: ProductCategoryService, private localicationsService: LocalizationService) {
    this.localicationsService.currentLanguage$.pipe(takeUntil(this.destroy$)).subscribe((lang) => {
      this.currentLang = lang;
    });
  }


  ngOnInit(): void {
    this.initJsTree();
  }

  initJsTree(): void {
    $(this.treeContainer.nativeElement).jstree({
      core: {
        data: (node: any, cb: any) => {
          if (node.id === '#') {
            this.loadRootNodes(cb);
          } else {
            this.loadChildNodes(node.id, cb);
          }
        },
        "themes": {
          "responsive": false
        }
      },
      "types": {
        "default": {
          "icon": "fa fa-folder"
        },
        "file": {
          "icon": "fa fa-file"
        }
      },
      plugins: ["types"]
    });

    $(this.treeContainer.nativeElement)
      .on('select_node.jstree', (e, data) => {
        console.log('Node selected:', data.node);
      });
  }

  private loadRootNodes(cb: Function): void {
    this.productCategoriesService
      .listProductCategories(1, 100, '', {
        logic: 'AND',
        field: 'ParentId',
        value: null,
        operator: 'EQ'
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          const nodes = response.data.map((cat: ProductCategory) => ({
            id: cat.id,
            text: cat.nameEn,
            children: true,
            icon: 'fa fa-folder'
          }));
          cb(nodes);
        },
        error: (error) => {
          const msg = this.currentLang === 'en' ? 'Failed to load categories' : 'فشل في تحميل الفئات';
          Swal.fire('Error', msg, 'error');
          cb([]);
        }
      });
  }

  private loadChildNodes(parentId: string, cb: Function): void {
    this.productCategoriesService
      .listProductCategories(1, 100, '', {
        logic: 'AND',
        field: 'ParentId',
        value: parentId,
        operator: 'EQ'
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          const childNodes = response.data.map((cat: ProductCategory) => ({
            id: cat.id,
            text: cat.nameEn,
            children: true,
            icon: 'fa fa-folder'
          }));
          cb(childNodes);
        },
        error: (error) => {
          const msg = this.currentLang === 'en' ? 'Failed to load child categories' : 'فشل في تحميل الفئات الفرعية';
          Swal.fire('Error', msg, 'error');
          cb([]);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

